<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="filter-wrapper">
          <p class="title">Manage Filters:</p>
          <div class="filter-container">
            <div class="filter-item">
              <select class="nice-select" v-model="filters.pm" @change="filterList">
                <option value="all">PM: All</option>
                <option v-for="(pm, sk) in pms" :key="sk" :value="pm">{{ pm }}</option>
              </select>
            </div>
            <div class="filter-item search-filter">
              <input type="text" placeholder="Search" v-model="filters.search">
              <button type="button" @click="filterList"><i class="fa fa-search"></i></button>
            </div>
            <div class="filter-reset-btn">
              <a href="javascript:void(0)" title="Refresh" @click="resetFilter">
                <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
              </a>
            </div>
             <div class="float-right">
              <router-link
                :to="{ path: `/drawings/duplicate/new` }"
                class="btn btn-custom pt-2 pb-2 rounded">
                <span><i class="fas fa-plus-square"></i>&nbsp; New</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive">
          <div id="list-projj" class="list-proj" @scroll="scrollList">
            <div class="row list-head">
              <div class="col" data-key="quote_number" @click="sortList">Quote Number</div>
              <div class="col" data-key="company_name" @click="sortList">Company Name</div>
              <div class="col" data-key="project_name" @click="sortList">Project Name</div>
              <!-- <div class="col" data-key="pdf_date_final" @click="sortList">PDF Date</div> -->
              <div class="col" data-key="created_at" @click="sortList">Date Created</div>
            </div>
            <div class="list-row" v-for="(row, di) in drawingCopies" :key="row.id" :ref="`row${row.id}`">
              <div class="row list-data" :data-row="di">
                <div class="col">{{ row.quote_number }}</div>
                <div class="col">{{ row.company_name }}</div>
                <div class="col" style="word-break: break-word;">{{ row.project_name }}</div>
                <!-- <div class="col">{{ row.pdf_date_final }}</div> -->
                <div class="col">{{ row.created_at }}</div>
              </div>
              <div class="row list-action">
                  <div class="col-md-12 action-wrap">
                    <div class="action-links">
                      <template v-if="row.drawing_status == 'generating' || row.drawing_status == 'waiting' || row.drawing_status == 'processing'">
                        <span>Generating...</span>
                        <a v-if="row.pdf_drill" target="_blank" :href="'/api/' + row.pdf_drill">DRILL</a>
                      </template>
                      <template v-else>
                        <a @click="edit(row)">EDIT</a>
                        <template v-if="row.drawing_status != 'failed'">
                          <span v-if="(requesting3D.includes(row.id) || row.requested_3d == 'Yes') && !row.file_3d">Requesting 3D...</span>
                          <a v-else-if="row.file_cad && row.requested_3d === 'No'" @click="request3D(row.id, di)">Request 3D</a>
                          <a v-if="row.file_3d" target="_blank" :href="'/api/' + row.file_3d">3D</a>
                          <a v-if="row.file_cad" target="_blank" :href="'/api/' + row.file_cad">CAD</a>
                          <a v-if="row.pdf_drawing" target="_blank" :href="'/api/' + row.pdf_drawing">DRAWING</a>
                          <a v-if="row.pdf_drill" target="_blank" :href="'/api/' + row.pdf_drill">DRILL</a>
                          <a v-if="row.pdf_manu" target="_blank" :href="'/api/' + row.pdf_manu">Manufacturing</a>
                        </template>
                        <template v-else>
                          <span style="color: red;">Drawing Failed!</span>
                        </template>
                      </template>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <template v-if="drawingCopies.length === 0 && !isListLoading">
          <p class="no-results-msg">No results found</p>
        </template>
        <template v-if="isListLoading">
          <div class="progress">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100"
              style="width: 100%"></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { DuplicateDrawing } from '../../api/drawing/duplicate'

export default {
  name: 'DuplicateDrawing',
  data() {
    return {
      filters: {
        search: '',
        pm: 'all'
      },
      currentUser: {},
      selectedCopy: {},
      drawingCopies: [],
      page: 1,
      isListLoading: false,
      last_page: 1,
      order_by: 'created_at',
      order: 'desc',
      stopLoads: false,
      waiting: false,
      generating: false,
      checking: false,
      gen3dstart: 0,
      requesting3D: [],
      is3DRequest: false,
      pms: []
    }
  },
  mounted() {
    let def_order = document.querySelector('#list-projj .list-head .col[data-key='+this.order_by+']')
    def_order.classList.add(this.order)
    def_order.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
    document.getElementById("list-projj").addEventListener('scroll', this.scrollList);

    this.me()
    this.getPms()
  },
  methods: {
    me() {
      if (localStorage.getItem('user')) {
        this.currentUser = JSON.parse(localStorage.getItem('user'))
      } else {
        this.$http.get('/api/me').then((res) => {
          localStorage.setItem('user', JSON.stringify(res.data))
          this.currentUser = res.data
        }).catch(() => {})
      }
    },
    getPms() {
      this.$http.get(`/api/project-filter-pms`).then((response) => {
        if (response.data.pms) {
          this.pms = response.data.pms
          if (this.pms.includes(this.currentUser.username)) {
            this.filters.pm = this.currentUser.username
          }
        }
        this.getDrawingCopies(1)
      })
    },
    getDrawingCopies(page) {
      this.isListLoading = true
      const params = {
        page: page,
        order_by: this.order_by,
        order: this.order,
        search: this.filters.search,
        pm: this.filters.pm
      }
      if ( page == 1 ) {
        this.drawingCopies = [];
        this.page = 1;
        this.stopLoads = false;
      }
      DuplicateDrawing(params, 'get').then(response => {
        if ( page == 1 ) this.drawingCopies = response.data.copies;
        else this.drawingCopies = this.drawingCopies.concat(response.data.copies);
        
        if ( !response.data.copies.length ) this.stopLoads = true;
      
        this.generating = this.drawingCopies.filter(p => p.drawing_status == "generating")
        if ( this.generating ) this.checkDrawings()
        
        var r3ds = this.drawingCopies.filter(p => p.requested_3d == "Yes" && !p.file_3d)
        if ( r3ds.length > 0 ) this.check3Ds()
        
        this.waiting = this.drawingCopies.filter(p => p.drawing_status == "waiting")
        if ( this.waiting ) this.checkWaiting()

        this.isListLoading = false
      }).catch(error => {
        console.log(error)
        this.isListLoading = false
      })
    },
    scrollList({ target: { scrollTop, clientHeight, scrollHeight }}) {
      if (scrollTop + clientHeight >= (scrollHeight - 100) && !this.stopLoads && !this.isListLoading) {
        this.page += 1;
        this.getDrawingCopies(this.page);
      }
    },
    sortList(e) {
      if(!this.isListLoading) {
        Array.from(document.querySelectorAll('#list-projj .list-head .col')).forEach((el) => {
            el.classList.remove('asc', 'desc')
        })
        let element = document.querySelector('#list-projj .list-head .col[data-key='+e.target.dataset.key+']')
        this.order_by = e.target.dataset.key
        this.order = element.dataset.order || 'asc'
        element.classList.add(this.order)
        element.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
        this.page = 1
        this.drawingCopies = []
        this.getDrawingCopies(1)
      }
    },
    filterList() {
      this.page = 1
      this.drawingCopies = []
      this.getDrawingCopies(1)
    },
    resetFilter() {
      this.filters = {
        search: '',
        pm: this.currentUser.username
      }
      this.filterList()
    },
    edit(row) {
      this.$router.push(`/drawings/edit/${row.id}`)
    },
    checkWaiting() {
      const api = '/api/duplicate-drawings/check/waiting';
      let waiting = [];
      this.drawingCopies.map(function(o, i) {
        if ( o.drawing_status == "waiting" ) waiting.push({ key : i, id : o.id })
      })
      this.$http.get(api).then((response) => {
        for(let w in waiting) this.drawingCopies[waiting[w].key].drawing_status = 'generating';
        if ( response.data.length ) this.checkDrawings();
      })
    },
    checkDrawings() {
      if ( this.checking ) return false

      let generating = []
      this.drawingCopies.map(function(o, i) {
          if ( o.drawing_status == "generating" ) generating.push({ key : i, id : o.id })
      });
      this.generating = generating
      if ( !generating.length ) return false

      const api = '/api/duplicate-drawings/check/generated'
      let dataParams = { ids : [] }
      for ( let i in this.generating ) dataParams.ids.push(this.generating[i].id)
      this.checking = true
      this.$http.get(api,{ params: dataParams }).then((response) => {
        this.checking = false
        const genProjects = response.data.generated
        if ( genProjects.length > 0 ) {
          for(let i in genProjects ) {
            let proj = this.generating.filter(p => p.id == genProjects[i].id)
            if ( proj.length > 0 ) {
              this.$set(this.drawingCopies, proj[0].key, genProjects[i])
              alert(genProjects[i].quote_number + ' drawing has been generated.')
            }
          }
        } else if ( this.$route.path === '/drawings' ) {
          setTimeout(this.checkDrawings, 5000)
        }
      })
      .catch((error) => {
        console.log(error)
        this.checking = false
      })
    },
    request3D(project_id, index) {
      this.requesting3D.push(project_id);
      const api = '/api/duplicate-drawings/request3D/'+project_id;
      this.$http.get(api).then((response) => {
        var r = response.data;
        // console.log('respo request 3D', r);
        if ( r.status == 'success' ) this.$set(this.drawingCopies, index, r.copy);
        if ( r.status == 'waiting' ) {
          alert('Waiting for 3D to be generated');
          this.$set(this.drawingCopies[index], 'requested_3d', 'Yes');
          this.check3Ds();
        }

        if ( r.status == 'failed' ) {
          alert('Error: ' + r.message);
        } else {
          for ( var r3 in this.requesting3D ) {
            if ( this.requesting3D[r3] == project_id ) delete this.requesting3D[r3];
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    check3Ds() {
      if ( this.is3DRequest ) return false;
      const api = '/api/duplicate-drawings/check/generated3D';
      var dataParams = { ids : [] };
      this.drawingCopies.map(function(o){
        if ( o.requested_3d == "Yes" && !o.file_3d ) dataParams.ids.push(o.id);
      });
      this.is3DRequest = true;
      if ( dataParams.ids === [] ) return false;

      this.$http.get(api,{ params: dataParams }).then((response) => {
        this.is3DRequest = false;
        const genProjects = response.data.generated;
        if ( genProjects.length > 0 ) {
          for(var x in genProjects ) {
            this.drawingCopies.map(function(o,i){
              if ( o.id == genProjects[x].id && genProjects[x].file_3d ) {
                alert(genProjects[x].quote_number+' 3D has been generated.');
                o.file_3d = genProjects[x].file_3d;
                this.$set(this.drawingCopies[i], 'file_3d', genProjects[x].file_3d);
                this.$set(this.drawingCopies[i], 'requested_3d','');

                for ( var r3 in this.requesting3D ) {
                  if ( this.requesting3D[r3] == o.id ) delete this.requesting3D[r3];
                }
              }
            });
            this.reset();
          }
        } else if ( this.$route.path === '/drawings' ) {
          setTimeout(this.check3Ds, 5000);
        }
      })
      .catch((error) => {
          console.log(error)
          this.is3DRequest = false;
      });
    },
  }
}
</script>
<style lang="scss" scoped>
#list-projj {
    min-width: 700px;
    padding-right: 12px;
    .list-head {
        .col {
            background-image: url('/api/public/img/bg.png');
            background-position: center right;
            background-repeat: no-repeat;
            cursor: pointer;
            white-space: normal;
            vertical-align: middle;
            &.asc {
                background-image: url('/api/public/img/trans-asc.png');
            }
            &.desc {
                background-image: url('/api/public/img/trans-desc.png');
            }
            &.sort-false {
                background-image: none;
                cursor: default;
            }
        }
    }
}
.progress {
    border-radius: 0;
}
.no-results-msg {
    text-align: center;
    padding: 0.5em;
    font-size: 11px;
}
.row-detail {
    display: flex;
    align-items: center;
    word-break: break-all;
    padding: 0.2em;
    label {
        min-width: 130px;
        font-weight: bold;
        margin: 0;
    }
}
.modal-view.modal::v-deep {
    .modal-dialog {
        max-width: 992px;
    }
}
.modal-approve.modal::v-deep {
    .modal-dialog {
        max-width: 768px;
    }
}
.list-proj .row .action { display: inline-block; padding: 7px; border: 0; letter-spacing: 0.3px; color: #fff; text-decoration: none; min-width: 86px; cursor: pointer; color: #fff; background-color: #5cb85c; margin-left: 6px; vertical-align: middle; }
.list-proj .row .action span { display: inline-block; background: #459e45; padding: 2px 7px; width: 29px; margin: -7px 2px -7px -8px; font-size: 17px; line-height: 26px; text-align: center; }
.list-proj .row .action.action-red { background: #c90000; }
.list-proj .row .action.action-red span { background: #8b0000; }
.badge {
    cursor: text;
    pointer-events: none;
    border-radius: 0;
    min-width: 84px;
    padding: 7px;
    border: 0;
    letter-spacing: .3px;
    color: #fff;
    text-decoration: none;
}
.badge-pending {
    background-color: gold;
}
.badge-approved {
    background-color: #459e45;
}
.badge-rejected {
    background-color: #c90000;
}
@media (max-width: 768px) {
    #list-projj {
        min-width: 1200px;
    }
}
@media (min-width: 1200px) {
    .filter-wrapper {
        .filter-item {
            width: 19.4%;
            &.search-filter {
                width: 29.6% !important;
            }
        }
    }
}
</style>
